import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CONCEPT_DOMAIN,
  CONCEPT_NOTE_BELIEFS_DETAIL_ENDPOINT,
  conceptApi,
} from "api/conceptApi";

import CustomModal from "components/common/CustomModal";
import Link from "components/common/Link";
import { useCallback, useState } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";

export default function ConceptNoteConfirmButton({
  conceptNoteKey,
  label,
  disabled,
}: {
  conceptNoteKey: string;
  label: string;
  disabled?: boolean;
}) {
  const queryClient = useQueryClient();
  const patientState = useRecoilValue(patientAtom);

  const confirmConceptNoteQueryFn = useCallback(
    () =>
      conceptApi.confirmConceptNote(
        patientState?.patientId!!,
        `${conceptNoteKey}`
      ),
    [patientState?.patientId, conceptNoteKey]
  );

  const { mutate: confirmConceptNote } = useMutation(
    confirmConceptNoteQueryFn,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          CONCEPT_DOMAIN,
          CONCEPT_NOTE_BELIEFS_DETAIL_ENDPOINT,
          patientState?.patientId,
        ]);
      },
    }
  );

  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) setOpen(true);
        }}
      >
        <Link text="확정" opacity={disabled ? 0.4 : 1} textColor="primary.solid" />
      </div>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title={`이 ${label}(으)로 <${label} 살펴보기>를 진행해도 될까요?`}
        subtitle={""}
        actions={[
          {
            label: "확정하기",
            variant: "Solid",
            onClick: () => {
              confirmConceptNote();
              setOpen(false);
            },
          },
        ]}
      />
    </>
  );
}